'use strict';

const tnyMain = require('../tny_main');

/**
 * 「もっと見る」ボタンへのクリックイベント設定。
 *
 * @param {JQuery.Event} event - クリックイベント 例：`{originalEvent: PointerEvent, type: 'click', target: button#showMoreBtn, ...}`
 * @returns {void}
 */
function setClickShowMoreBtn() {
    $('#showMoreBtn').on('click', function (event) {
        // 通常のアクションをキャンセルする。(ボタンのため実施しなくても問題はないが念のため)
        event.preventDefault();
        // DOMツリーのイベント伝搬をキャンセルする。(親要素にクリックイベントは割り当てられていない想定だが念のため)
        event.stopPropagation();

        const $showMoreBtn = $(this);
        const showMoreUrl = $showMoreBtn.data('url');
        $.spinner().start();
        $.ajax({
            method: 'GET',
            url: showMoreUrl,
        })
            .done((data) => {
                // 受け取ったHTMLでgridFooter部分を置き換える。
                const $newItemGrid = $('#newItemGrid');
                const $gridFooter = $('#gridFooter', $newItemGrid);
                $gridFooter.replaceWith(data);
                // 新しい要素をフェードインの監視対象に追加する。
                const $newTiles = tnyMain.addObserverFadeIn('._unobserved-fade-in', $newItemGrid);
                // 監視対象用のマーカーを削除する。
                $newTiles.removeClass('_unobserved-fade-in');
                // 新しいshowMoreBtnに再度クリックイベントを割り当てる。
                setClickShowMoreBtn();
            })
            .fail(() => {
                // 参照画面のため何もしない。
            })
            .always(() => {
                $.spinner().stop();
            });
    });
}

// 初期表示時に実行する関数をexportする。
module.exports = {
    setClickShowMoreBtn,
};
